import { NavLink } from 'react-router-dom';
import { usePrefetchSubCategory } from '../subCategoryPage/useSubCategoryPage';

export const SingleCategorySubcategories = ({
  category,
  subcategory,
  isLoadingSubcategories,
}) => {
  if (isLoadingSubcategories) {
    return <SubcategorySkeletons />;
  }

  if (!subcategory?.length) {
    return null;
  }

  return (
    <>
      {subcategory.map((sub) => (
        <SubcategoryLink key={sub.slug} category={category} subcategory={sub} />
      ))}
    </>
  );
};

const SubcategorySkeletons = () => (
  <>
    {Array.from({ length: 5 }).map((_, i) => (
      <li
        key={i}
        className="flex flex-col items-center animate-pulse space-y-1"
      >
        <div className="h-4 w-20 bg-gray-300 rounded" />
      </li>
    ))}
  </>
);

const SubcategoryLink = ({ category, subcategory }) => {
  const prefetchProps = usePrefetchSubCategory();
  const to = `/${category}/${subcategory.slug}`;

  // if (subcategory.slug === 'rent-smallsmall') {
  //   return (
  //     <li className="flex flex-col items-center hover:cursor-pointer transition-all duration-300 ease-in-out">
  //       <a
  //         href="https://rent.smallsmall.com/"
  //         target="_blank"
  //         rel="noopener noreferrer"
  //         className="text-sm font-medium text-nowrap px-2 py-1 transition-transform duration-300"
  //       >
  //         <span className="text-gray-700">{subcategory.name || 'No Name'}</span>
  //       </a>
  //     </li>
  //   );
  // }

  return (
    <li className="flex flex-col items-center hover:cursor-pointer transition-all duration-300 ease-in-out">
      <NavLink
        to={to}
        {...prefetchProps(to)}
        className={({ isActive }) =>
          `text-sm font-medium text-nowrap px-2 py-1 transition-transform duration-300 ${
            isActive ? 'border-b border-black scale-105' : ''
          }`
        }
      >
        <span className="text-gray-700 capitalize">
          {subcategory.name || 'No Name'}
        </span>
      </NavLink>
    </li>
  );
};
